module.exports = __webpack_public_path__ + "static/media/også.20df6ffc.mp3";